import {v4 as uuidv4} from 'uuid';

export function generateId() {
  return uuidv4();
}

export function generateCurrentUnixTimestamp() {
  return Math.round(new Date().getTime() / 1000);
}